import { render, staticRenderFns } from "./updatePTLC.vue?vue&type=template&id=04c654b2&lang=pug&"
import script from "./updatePTLC.vue?vue&type=script&lang=js&"
export * from "./updatePTLC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports